import { dependencies } from '@pn/core/dependencies';
import type { User } from '@pn/core/domain/user';

/**
 * Kept free of runtime imports from `userSlice` (and therefore from
 * `domain/settings`) because `handleError` depends on this module and
 * pulling in the slice creates a circular import chain via `domain/map`.
 */
export const CURRENT_USER_SLICE_NAME = 'currentUser';

/**
 * Synchronous reads of the current user for code that runs outside React,
 * where `useCurrentUserStorage()` isn't available: error logging, operations,
 * and API mappers deciding which library folder an item goes in or whether
 * it's shown. Use the hook everywhere else.
 */
export function getCurrentUserId(): User['id'] | undefined {
  try {
    return dependencies.store.getState()[CURRENT_USER_SLICE_NAME].user?.id;
  } catch {
    return 'ERROR';
  }
}

export function getCurrentUser(): User | undefined {
  return dependencies.store.getState()[CURRENT_USER_SLICE_NAME].user;
}
